/**
 * Le iniziali per un avatar: prima lettera di nome e cognome ricavate da `displayName`. Un
 * nome di una sola parola non lascia la cella vuota, ne prende solo la prima lettera. Un
 * nome mancante o vuoto ritorna «?».
 */
export default function iniziali(displayName) {
    const parti = (displayName || '').trim().split(/\s+/).filter(Boolean);
    if (parti.length === 0) {
        return '?';
    }
    if (parti.length === 1) {
        return parti[0].charAt(0).toUpperCase();
    }
    return (parti[0].charAt(0) + parti[parti.length - 1].charAt(0)).toUpperCase();
}
